<template>
  <div class="Ordercontent">
    <van-tabs v-model="active" @click="changeTab">
      <van-tab title="全部">
        <van-row  :disabled="item.status!=0" v-for="item in OrderList" :key="item.ID" v-if="OrderList">
          <a href="javascript:;" class="billBar" @click="gotoOrderPay(item)">
            <van-col span="2">
              <span class="Status StayColor" v-if="item.status == '0'">待</span>
              <span class="Status Coloring" v-if="item.status == '1,5,6,7'">维</span>
              <span class="Status CompleteColor" v-if="item.status == '10'">已</span>
            </van-col>
            <van-col span="23" offset="1">
              <van-row >
                <van-col span="24" class="cont">
                  <van-col span="24" class="address">{{item.address}}</van-col>
                  <van-col span="24" class="reason">{{item.reason}}</van-col>
                </van-col >
                <van-col span="24" class="statusText" v-if="item.status == '0'">待接单</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '1,5,6,7'">维修中</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '10'">已完成</van-col>
              </van-row>
            </van-col>
          </a>
        </van-row>
        <van-row  class="noPayBar" v-if="OrderList.length == 0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
          <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
        </van-row>
      </van-tab>
      <van-tab title="待分配">
        <van-row  :disabled="item.status!=0" v-for="item in OrderList" :key="item.ID" v-if="OrderList">
          <a href="javascript:;" class="billBar" @click="gotoOrderPay(item)">
            <van-col span="2">
              <span class="Status StayColor" v-if="item.status == '0'">待</span>
              <span class="Status Coloring" v-if="item.status == '1,5,6,7'">维</span>
              <span class="Status CompleteColor" v-if="item.status == '10'">已</span>
            </van-col>
            <van-col span="23" offset="1">
              <van-row >
                <van-col span="24" class="cont">
                  <van-col span="24" class="address">{{item.address}}</van-col>
                  <van-col span="24" class="reason">{{item.reason}}</van-col>
                </van-col >
                <van-col span="24" class="statusText" v-if="item.status == '0'">待接单</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '1,5,6,7'">维修中</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '10'">已完成</van-col>
              </van-row>
            </van-col>
          </a>
        </van-row>
        <van-row  class="noPayBar" v-if="OrderList.length == 0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
          <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
        </van-row>
      </van-tab>
      <van-tab title="维修中">
        <van-row  :disabled="item.status!=0" v-for="item in OrderList" :key="item.ID" v-if="OrderList">
          <a href="javascript:;" class="billBar" @click="gotoOrderPay(item)">
            <van-col span="2">
              <span class="Status StayColor" v-if="item.status == '0'">待</span>
              <span class="Status Coloring" v-if="item.status == '1,5,6,7'">维</span>
              <span class="Status CompleteColor" v-if="item.status == '10'">已</span>
            </van-col>
            <van-col span="23" offset="1">
              <van-row >
                <van-col span="24" class="cont">
                  <van-col span="24" class="address">{{item.address}}</van-col>
                  <van-col span="24" class="reason">{{item.reason}}</van-col>
                </van-col >
                <van-col span="24" class="statusText" v-if="item.status == '0'">待接单</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '1,5,6,7'">维修中</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '10'">已完成</van-col>
              </van-row>
            </van-col>
          </a>
        </van-row>
        <van-row  class="noPayBar" v-if="OrderList.length == 0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
          <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
        </van-row>
      </van-tab>
      <van-tab title="已完成">
        <van-row  :disabled="item.status!=0" v-for="item in OrderList" :key="item.ID" v-if="OrderList">
          <a href="javascript:;" class="billBar" @click="gotoOrderPay(item)">
            <van-col span="2">
              <span class="Status StayColor" v-if="item.status == '0'">待</span>
              <span class="Status Coloring" v-if="item.status == '1,5,6,7'">维</span>
              <span class="Status CompleteColor" v-if="item.status == '10'">已</span>
            </van-col>
            <van-col span="23" offset="1">
              <van-row >
                <van-col span="24" class="cont">
                  <van-col span="24" class="address">{{item.address}}</van-col>
                  <van-col span="24" class="reason">{{item.reason}}</van-col>
                </van-col >
                <van-col span="24" class="statusText" v-if="item.status == '0'">待接单</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '1,5,6,7'">维修中</van-col>
                <van-col span="24" class="statusText" v-if="item.status == '10'">已完成</van-col>
              </van-row>
            </van-col>
          </a>
        </van-row>
        <van-row  class="noPayBar" v-if="OrderList.length == 0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
          <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
        </van-row>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { Dialog } from 'vant';
  import { reqRepairOrderList } from '../../api'
	export default {
    name:"order",
	  data(){
	    return{
        active:0,
        orderData:{
          userId:'',
          // orderType:'0',
          status:'0,1,5,6,7,15'//0,1全部  0待  1已
        },
        OrderList:''
      }
    },
    created(){
      this.orderData.userId = this.$cookies.get('userInfo').userId
    },
    mounted(){
      this.getOrderList();
    },
    methods:{
	    /*
	    * 获取订单列表
	    * */
      getOrderList(){
        reqRepairOrderList(this.orderData).then(res => {
          if(res.success){
            this.OrderList = res.data
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
      },
      /*
      * 点击切换tab，通过active的不同来获取对应数据
      * */
      changeTab(){
        if(this.active==0){
          //全部
          this.orderData.status = '0,1,5,6,7,15'
        }else if(this.active==1){
          //待分配
          this.orderData.status = '0'
        }else if(this.active==2){
          //维修中
          this.orderData.status = '1,5,6,7'
        }else if(this.active==3){
          //已完成
          this.orderData.status = '15'
        }
        this.getOrderList()
      },
      /*
      * 查看订单详情
      * */
      gotoOrderPay(data){
		let imageurls = "";
		if(data.imageurls){
			imageurls = data.imageurls.split(",");
		}
        let repairorderInfo = {
          address:data.address,
          createTime:data.createTime,
          imageurls:imageurls,
          name:data.name,
          phone:data.phone,
          reason:data.reason,
          id:data.id,
          status:data.status,
        }
        this.$cookies.remove('repairorderInfo');
        this.$cookies.set('repairorderInfo',repairorderInfo);
        this.$router.push({
          path:'/repairorderdetail',
          name:'repairorderdetail'
        });
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .orange
    color #ff6d02
  .Ordercontent
    padding-bottom 80px
    background #f9f9f9
    .van-tabs--line
      .van-tabs__wrap
        height 90px
      .van-tab
        font-size 30px
        line-height 80px
      .van-tab--active
        color #ff6d02
      .van-tabs__content
        padding-top 60px
        .billBar
          display inline-flex
          padding 0px 40px 30px 0px
          background #fff
          border-top 20px solid #f9f9f9
          .Status
            position relative
            top 25%
            left 30%
            display inline-block
            padding 20px 20px
            border-radius 50%
            color #fff
            font-size 32px
          .StayColor
            background #397ff0
          .Coloring
            background #ff6d02
          .CompleteColor
            background #d81b60
          .van-row
            padding-left 25px
          .cont
            border-bottom 2px solid #f0f0f0
            font-size 28px
            color #888888
            padding 20px 0px
          .address
            font-size 30px
            color #222222
            line-height 40px
            padding 20px 0px
          .statusText
            padding-top 20px
            font-size 28px
            color #888888
    .noPayBar
      margin 10px 0px
      height 626px
      background #ffffff
      text-align center
      .noPayPC
        height 50%
        margin-top 15%
        background url("./images/unfound_5.png") no-repeat center
        background-size 50% auto
      .text1
        font-size 32px
        padding 20px 0px
      .text2
        font-size 24px
        color #aaaaaa
    .van-swipe-cell__right
      padding-top 20px
      .van-button
        width 165px
        height 100%
        font-size 28px
        text-align center
        letter-spacing 6px
</style>



// WEBPACK FOOTER //
// src/pages/repairOrder/repairOrder.vue